export default "__VITE_ASSET__DT0F_Xh2__"